import { RootState } from "../../../../Store/index";

export const selectPaddleProductList = (state: RootState) =>
  state.PaddleProductReducer.productList;

export const selectCurrentPaddleProduct = (state: RootState) =>
  state.PaddleProductReducer.currentProduct;

export const selectIsPaddleProductLoading = (state: RootState) =>
  state.PaddleProductReducer.isLoading;

export const selectFeatureGroups = (state: RootState) =>
  state.PaddleProductReducer.featureGroups;

export const selectProductEditions = (state: RootState) =>
  state.PaddleProductReducer.productEditions;

